import { tvpil } from '../compat/tvpil';
import { composePaginatedData } from '../utils';

import { getContinueWatchingQueryData } from './queries';

export type GetContinueWatchingArgs = {
  pageSize: number;
  referenceId: string;
};

export function getContinueWatching({ referenceId, pageSize }: GetContinueWatchingArgs) {
  const category = tvpil.categoryTreeItemsMap.get(referenceId);

  if (!category) {
    return undefined;
  }

  const data = getContinueWatchingQueryData({ pageSize, referenceId });

  if (!data) {
    return [];
  }

  return composePaginatedData({ data, limit: category.railProperty.railItemsLimit });
}
